export interface SocialLink {
  href: string;
  title: string;
  ariaLabel: string;
  platform: "x" | "linkedin" | "instagram" | "tiktok";
}

export const socialLinks: SocialLink[] = [
  {
    href: "https://x.com/ArtiCollectHQ",
    title: "Follow us on X (Twitter)",
    ariaLabel: "Follow Articollect on X (Twitter)",
    platform: "x",
  },
  {
    href: "https://www.linkedin.com/company/articollect",
    title: "Connect with us on LinkedIn",
    ariaLabel: "Connect with Articollect on LinkedIn",
    platform: "linkedin",
  },
  {
    href: "https://www.instagram.com/articollect_official",
    title: "Follow us on Instagram",
    ariaLabel: "Follow Articollect on Instagram",
    platform: "instagram",
  },
  // Uncomment when TikTok is ready
  // {
  //   href: "https://tiktok.com/@articollect_official",
  //   title: "Follow us on TikTok",
  //   ariaLabel: "Follow Articollect on TikTok",
  //   platform: 'tiktok'
  // }
];
